import { render, staticRenderFns } from "./MaterialsPriceUpdateDropdown.vue?vue&type=template&id=593e0938&"
import script from "./MaterialsPriceUpdateDropdown.vue?vue&type=script&lang=js&"
export * from "./MaterialsPriceUpdateDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports